import { companyInfo } from "@/mocks/homeData";

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[750px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20digital%20network%20of%20interconnected%20glowing%20nodes%20representing%20global%20education%20and%20cultural%20exchange%2C%20dark%20navy%20blue%20background%20with%20warm%20golden%20light%20particles%2C%20floating%20geometric%20shapes%20symbolizing%20knowledge%20bridges%20between%20continents%2C%20cinematic%20wide%20angle%20composition%20with%20soft%20bokeh%20lights%2C%20modern%20corporate%20art%20style%20with%20a%20sense%20of%20hope%20and%20connection&width=1920&height=800&seq=hero1&orientation=landscape"
          alt="글로벌 교육 문화 교류 배경"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-950/70 via-navy-900/60 to-navy-950/80" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 text-center pt-20">
        <p className="animate-on-scroll text-sky-300 text-sm md:text-base font-medium tracking-widest uppercase mb-4 md:mb-6">
          {companyInfo.enName}
        </p>

        <h1 className="animate-on-scroll delay-100 text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 md:mb-8 max-w-4xl mx-auto">
          교육을 키우며,
          <br />
          문화를 연결하고,
          <br />
          <span className="text-sky-300">미래를 함께합니다</span>
        </h1>

        <p className="animate-on-scroll delay-200 text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          글로벌 교육·문화·체육 교류의 중심에서
          <br className="hidden md:block" />
          국내외 인재와 지역사회를 연결하는 플랫폼 기업
        </p>

        <div className="animate-on-scroll delay-300 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="#about"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="whitespace-nowrap px-6 md:px-8 py-3 md:py-3.5 bg-sky-500 hover:bg-sky-400 text-white text-sm md:text-base font-semibold rounded-lg transition-colors"
          >
            회사 소개 보기
          </a>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="whitespace-nowrap px-6 md:px-8 py-3 md:py-3.5 border border-white/30 hover:border-white/60 text-white text-sm md:text-base font-medium rounded-lg transition-colors"
          >
            문의하기
          </a>
        </div>

        <div className="animate-on-scroll delay-400 mt-12 md:mt-16 flex items-center justify-center gap-2 text-white/60 text-sm">
          <i className="ri-link text-sky-300" />
          <span className="tracking-wider font-medium">{companyInfo.vision}</span>
        </div>
      </div>
    </section>
  );
}